import { Item } from '@factorialco/deprecated-design-system'
import { Form } from 'factorial-form'
import { A3InnuvaRegimeDocument, A3innuvaRegimeCodeFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import DropdownSearchBar from 'modules/core/components/DropdownSearchBar'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { SpanishContractData } from 'modules/contracts/hooks/useFetchSpanishContractData'
import { translate } from 'modules/contracts/lib/translate'
import { regimeCodesToOptions } from 'modules/payroll_integrations_a3innuva/lib/a3innuvaHelpers'

interface Props {
  form: Form
  spanishContractData: SpanishContractData
  translations: { [key: string]: string }
  legalEntityId: number
}

const Regime = ({ form, spanishContractData, translations, legalEntityId }: Props) => {
  const session = useCurrentSession()
  const regimeName = form.get('es_regime_payroll_integration_name').value
  const regimeId = form.get('es_regime_id').value
  const spainRegime = regimeId ? spanishContractData.regimes.get(Number(regimeId)) : null

  const setCurrentRegime = (regimes: A3innuvaRegimeCodeFragment[]) => {
    const currentRegime = regimes.find(({ name }) => name === spainRegime?.attributes.name)
    if (currentRegime) {
      form.setValues({
        es_regime_payroll_integration_code: currentRegime.code,
        es_regime_payroll_integration_name: currentRegime.name,
      })
    }
  }

  const isFormInitialized = () => {
    if (!form.has('es_regime_payroll_integration_name')) return false
    return form.get('es_regime_payroll_integration_name') === spainRegime?.attributes.name
  }

  const { data: regimeData, loading } = useQuery(A3InnuvaRegimeDocument, {
    variables: {
      companyId: session.company.id,
      currentUserId: session.access.userId,
      legalEntityId,
    },
  })
  const a3innuvaRegimes = regimeData?.payrollIntegrationsA3innuva.regimes ?? []

  if (!loading && !isFormInitialized()) {
    setCurrentRegime(a3innuvaRegimes)
  }

  const options = regimeCodesToOptions(a3innuvaRegimes)

  const labelNotFound = () => {
    return options.length
      ? i18n.t('contract_versions.forms.contract_extra_information.a3innuva.regime_not_found')
      : i18n.t('contract_versions.forms.contract_extra_information.a3innuva.label_not_found')
  }

  const onRegimeChanged = (item: Item) => {
    form.setValues({
      es_regime_payroll_integration_name: item.label,
      es_regime_payroll_integration_code: item.value,
      es_regime_id: undefined,
    })
  }

  return (
    <DropdownSearchBar
      name={regimeName || `-- ${i18n.t('common.none')} --`}
      label={translate(translations, 'regime') || ''}
      onSelect={onRegimeChanged}
      labelNotFound={labelNotFound()}
      data={options}
      searchLabel={i18n.t(
        'contract_versions.forms.contract_extra_information.a3innuva.search_label'
      )}
      loading={loading}
      popoverWidth="s400"
    />
  )
}

export default observer(Regime)
